import React from 'react'
import { connect, useDispatch } from 'react-redux'

import { setFullScreen } from '@store/actionSlices/appConfig'
import { ProjectIdentity, RootStateTypeExtra } from '@store/types'

import usePropertyCompareFirebaseTrigger from '@components/compare-property/utils'

import FirebaseControlQuery from '@firebaseUtil/firebase-control-query'

import { ArrowSvg } from '@svg/react'

interface ComponentProps {
  projectIdentity: ProjectIdentity
  activeLotId: string
  activeStageId: string
  className?: string
  iconClasses?: string
  onOverrideClick?: () => void
}

function BackButton({
  projectIdentity,
  activeLotId,
  activeStageId,
  className = 'rounded-full border-2 border-zinc-400 p-1',
  iconClasses = 'h-5 w-5 stroke-zinc-400',
  onOverrideClick,
}: ComponentProps) {
  const dispatch = useDispatch()

  const firebaseControlQuery = FirebaseControlQuery({
    ...projectIdentity,
    sessionKey: projectIdentity.sessionId,
  })

  const { triggerComparisonStop, isActive } =
    usePropertyCompareFirebaseTrigger()

  const PRECINCT_VIEW = 'precinct'

  const handleBackNav = async () => {
    if (isActive) {
      triggerComparisonStop()
      firebaseControlQuery.update({
        [`houseAndLand.activeLotId`]: '',
      })
      return
    }
    if (activeLotId) {
      firebaseControlQuery.update({
        [`houseAndLand.activeLotId`]: '',
      })
      return
    }
    if (activeStageId) {
      firebaseControlQuery.update({
        [`houseAndLand.activeStageId`]: '',
      })
      firebaseControlQuery.updateRoute(PRECINCT_VIEW)
      dispatch(setFullScreen(false))
    }
  }

  return (
    <button
      type="button"
      className={className}
      onClick={onOverrideClick ?? handleBackNav}
    >
      <ArrowSvg className={iconClasses} rotate="left" />
    </button>
  )
}

export default connect(
  ({ projectIdentity, firestore: { session } }: RootStateTypeExtra) => ({
    projectIdentity,
    activeLotId: session?.houseAndLand?.activeLotId || '',
    activeStageId: session?.houseAndLand?.activeStageId || '',
  })
)(BackButton)
